import React from 'react';
import type PlanSettingsInfoType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/plan-info/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - plan-info page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsPlanInfo = lazyForPaint<typeof PlanSettingsInfoType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-plan-info", jiraSpaEntry: "async-plan-settings-plan-info" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/plan-info'
			),
		),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyPlanSettingsPlanInfo} pageId="plan-settings-plan-info" shouldShowSpinner />
);
